import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { useAppDispatch, useAppSelector } from '@doda/common/src/redux/hooks';
import { useEffect } from 'react';
import {
  numOfVideoSelector,
  totalJobCountSelector,
} from 'redux/features/jobList';

import { useSelector } from 'react-redux';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useIsomorphicLayoutEffect } from '@doda/common/src/hooks/useIsomorphicLayoutEffect';
import { normalize } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { qualificationSelector } from 'redux/features/careerRecommendJobList';
import {
  measureImpressionCareerRecommendJobListAA,
  measureImpressionCareerRecommendJobListGA,
  measureVisibleNoResult,
} from '../../logics/careerRecommendJobListAnalytics';

/**
 * 資格求人一覧ページのAdobe AnalyticsおよびGoogle Analyticsの測定を行うカスタムフック
 */
export const useCareerRecommendJobListAnalytics = () => {
  const isAdobeScript = useAppSelector(adobeAnalyticsScriptsSelector);
  const dispatch = useAppDispatch();
  const query = useAppSelector(appQueryParamsSelector);
  const { name: qualificationName } = useAppSelector(qualificationSelector);
  const pageName = `資格求人一覧（${qualificationName}）`;
  const channel = '資格求人一覧';
  const numOfJob = useSelector(totalJobCountSelector);
  const numOfVideo = useSelector(numOfVideoSelector);

  /**
   * useEffectだとLaunch側PV発火に間に合わないためuseLayoutEffectでPV計測を行う
   * また、useLayoutEffectだとNext.jsでwarningが発生するためuseIsomorphicLayoutEffectを使用する
   */
  useIsomorphicLayoutEffect(() => {
    // useLayoutEffectでPV計測する関係で手動で正規化を行う
    normalize();
    // PV計測（AA）
    measureImpressionCareerRecommendJobListAA({
      pageName,
      channel,
      numOfVideo,
      numOfJob,
      query,
    });
    // PV計測（GA）
    measureImpressionCareerRecommendJobListGA({
      pageName,
      channel,
      query,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isAdobeScript) return;
    // useLayoutEffectでPV計測する関係で手動で正規化を行う
    normalize();
    // 0件の場合
    if (numOfJob === 0) measureVisibleNoResult(isAdobeScript, dispatch);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdobeScript]);
};
